<template>
    <div class="col-span-full grid-cols-subgrid items-center min-w-0 flex justify-end gap-1 @xl:col-span-1" role="cell">
        <slot></slot>
    </div>
</template>
